import React from 'react'
import STRINGS from 'utils/strings'
import { Container } from 'components/UIElements'
import Tags from './Tags'

const ParticipantArms = ({ ptpName, ptpArm }) => {
  const noArms = ptpArm ? null : <p>{`${ptpName} does not belong to an arm.`}</p>
  return (
    <Container className='arm-management-section' centered flex column>
      <div className='title'>{STRINGS.armManagement}</div>
      <div>{ptpArm ? <Tags disabled tags={[ptpArm]} /> : noArms}</div>
    </Container>
  )
}

export default ParticipantArms
